// 实训中心
import {
  guide01,
  guide02,
  guide03,
  guide04,
  guide05,
  guide05_1,
  guide06,
  guide07,
  guide08,
  guide09,
  guide10,
  guide11,
  guide12,
  guide13,
  guide14,
  guide15,
  guide16,
  guide17,
  guide18,
} from '@/utils/images.js'

const primaryGuide = [
  {
    id: 'guide-1',
    rightnavs: '实训中心',
    title: '第一步：创建课程实训',
    content: '',
    note: '',
    level: 1,
    children: [
      {
        id: 'guide-1-1',
        level: 2,
        content:
          '1、点击实训中心模块下的“创建课程实训”按钮进入新建课程实训界面，创建新的课程实训。',
        note: '',
        imgUrlList: [
          {
            url: guide01,
            label: '',
          },
        ],
      },
      {
        id: 'guide-1-2',
        level: 2,
        content: '2、在创建课程实训界面填写课程名称、课程描述、上传课程封面。',
        note: '',
        imgUrlList: [
          {
            url: guide02,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-2',
    level: 1,
    title: '第二步：添加实训项目',
    content: '（一）添加常规实训项目：',
    note: '',
    children: [
      {
        id: 'guide-2-1',
        level: 2,
        content:
          '1、 进入课程实训详情页面，点击“添加实训项目”按钮，添加实训项目。',
        note:
          '算法编程应用、行业创研应用、智能硬件应用属于常规实训项目类型，支持AI-T编辑器（积木模式）、AI-T编辑器（代码模式）和海龟库3种编辑方式进行项目编写。',
        imgUrlList: [
          {
            url: guide03,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-2-2',
        level: 2,
        content:
          '2、 在添加实训项目弹框界面填写实训项目名称、项目描述，选择实训项目类型和编辑方式。',
        note:
          '算法编程应用、行业创研应用、智能硬件应用属于常规实训项目类型，支持AI-T编辑器（积木模式）、AI-T编辑器（代码模式）和海龟库3种编辑方式进行项目编写。',
        imgUrlList: [
          {
            url: guide04,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-2-3',
        level: 2,
        content: '3、实训项目编写主要步骤：${contentArray}',
        contentArray: [
          '编写项目题面',
          '编写项目题解',
          '上传实训任务书、实训指导书',
        ],
        note:
          '下面以AI-T编辑器（积木模式）项目编辑为例，代码模式及其他编辑方式的原理流程一致。',
        imgUrlList: [],
        children: [
          {
            id: 'guide-2-3-1',
            level: 3,
            content:
              '1）点击进入添加好的实训项目，拖拽功能积木至编程区，完成项目题面设计后，点击“提交题面”，完成项目题面编写。',
            note: '',
            imgUrlList: [
              {
                url: guide05,
                label: '',
                display: '',
              },
            ],
          },
          {
            id: 'guide-2-3-2',
            level: 3,
            content:
              '2）拖拽功能积木至编程区，完成项目题解设计后，点击“提交代码”，完成项目题解编写。',
            note: '',
            imgUrlList: [
              {
                url: guide05_1,
                label: '',
                display: '',
              },
            ],
          },
          {
            id: 'guide-2-3-3',
            level: 3,
            content:
              '3）分别点击“导入实训任务书”和“导入实训指导书”，上传本地备好的实训任务书和实训指导书。',
            note: '',
            imgUrlList: [
              {
                url: guide06,
                label: '',
                display: 'inline',
              },
              {
                url: guide07,
                label: '',
                display: 'inline',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'guide-3',
    level: 1,
    title: '第三步：发布实训项目',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-3-1',
        level: 2,
        content:
          '1、在实训项目界面发布：完成实训项目编写后，点击“发布”，可将实训项目发布，此时项目状态为已发布未关联。',
        note: '',
        imgUrlList: [
          {
            url: guide08,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-3-2',
        level: 2,
        content:
          '2、在实训目录界面发布：点击“发布”，可将实训项目发布，此时项目状态为已发布未关联。',
        note: '',
        imgUrlList: [
          {
            url: guide09,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-4',
    level: 1,
    title: '第四步：关联用户',
    content: '',
    note:
      '关联用户是将课程实训与用户关联，只有被关联的用户才可查看和编辑该课程已发步的实训项目。',
    children: [
      {
        id: 'guide-4-1',
        level: 2,
        content:
          '1、在课程实训详情页面，点击“关联用户”按钮，进入关联用户界面。',
        note: '',
        imgUrlList: [
          {
            url: guide10,
            label: '',
            display: '',
          },
        ],
      },
      {
        id: 'guide-4-2',
        level: 2,
        content:
          '2、点击“添加用户”按钮，进入添加用户弹框界面，选择要关联的用户，完成用户关联。',
        note: '',
        imgUrlList: [
          {
            url: guide11,
            label: '',
            display: '',
          },
          {
            url: guide12,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    level: 2,
    footer:
      '至此，课程实训及实训项目的创建和发布、关联已经整体完成，登录被关联的用户账号便可以进行项目实训。',
  },
]

//附件
const secondGuide = [
  {
    theme: '附：内置课程实训',
    title: '附：内置课程实训',
    content: '',
    note: '',
    id: 'sec-1',
    level: 1,
    children: [
      {
        level: 2,
        id: 'sec-1-1',
        content:
          '1、查看内置课程：内置课程是系统为用户内置配套的课程实训，点击带有“内置”标识的课程实训，进入查看该课程实训详情。',
        note: '内置课程不可直接编辑，须复制后才可对该课程实训可查可编辑。',
        imgUrlList: [
          {
            url: guide13,
            label: '',
            display: '',
          },
          {
            url: guide14,
            label: '内置课程实训详情页面：',
          },
        ],
      },
      {
        level: 2,
        id: 'sec-1-2',
        content:
          '2、复制内置课程：鼠标悬浮在带有“内置”标识的课程上，点击“复制”图标按钮，复制内置课程实训。',
        note:
          '复制后的课程，标识为带有“精”的课程实训；对带有“精”标识的课程实训都可查可编辑，具体操作与上述实训项目创建及发布关联流程一致。',
        imgUrlList: [
          {
            url: guide15,
            label: '',
            display: '',
          },
          {
            url: guide16,
            label: '在弹框界面，编辑复制课程实训名称，完成内置课程复制。',
          },
          {
            url: guide17,
            label: '',
            display: '',
          },
        ],
        endNote:
          '复制后的课程，标识为带有“精”的课程实训；对带有“精”标识的课程实训都可查可编辑，具体操作与上述实训项目创建及发布关联流程一致。',
        footer: '关于实训中心模块的更多功能操作，可查看完整版用户手册了解哦～',
      },
    ],
  },
]
export default {
  primaryGuide,
  secondGuide,
}
